import api from "../../../store/AuthHeader";

const getFaqUser = () => {
    return api.get("/Faq/GetFaqForUser");
};

const getFaq = () => {
    return api.get("/Faq/GetFaq");
}

const updateFaq = (id: number, payload: any) => {
    return api.put(`/Faq/${id}`, payload);
}

export default {
    getFaqUser,
    getFaq,
    updateFaq
};